// extracted by mini-css-extract-plugin
export default {"Vcard":"Transaction_Vcard__+qXz3","VAcctTxt":"Transaction_VAcctTxt__mzPhy","VFundTxt":"Transaction_VFundTxt__2+gLP","VBank":"Transaction_VBank__-trk4"};